export default __webpack_public_path__ + "static/media/mojito.7c1950ed.svg";